export const ANIMATION_STAGES = {
  START: "start",
  MIDDLE: "middle",
  END: "end"
};

export const STAGE_ORDER = [
  ANIMATION_STAGES.START,
  ANIMATION_STAGES.MIDDLE,
  ANIMATION_STAGES.END
];

// Validation functions
export const isValidStage = stage =>
  Object.values(ANIMATION_STAGES).includes(stage);

export const getStageIndex = stage => STAGE_ORDER.indexOf(stage);

export const getNextStage = currentStage => {
  const currentIndex = getStageIndex(currentStage);
  return currentIndex < STAGE_ORDER.length - 1
    ? STAGE_ORDER[currentIndex + 1]
    : null;
};

export const getPreviousStage = currentStage => {
  const currentIndex = getStageIndex(currentStage);
  return currentIndex > 0 ? STAGE_ORDER[currentIndex - 1] : null;
};

// Enhanced pulse scale for character-level animations (letter/random textType).
// The default animate.css pulse uses 1.05 which is imperceptible on individual characters.
export const CHARACTER_PULSE_SCALE = 1.15;

// Default animation structure
export const createDefaultAnimation = stage => ({
  stage,
  name: "none",
  direction: "",
  delay: 0,
  transition: "",
  textType: "",
  isPreview: false,
  duration: null
});
